import { createSelector } from "reselect";

import parse from "../components/Markup/parser";

export const getHumans = (state) => state.humans;
export const getComments = (state) => state.humanComments;
export const getEvents = (state) => state.events;

const objInc = (obj, key) => {
  if (key in obj) {
    obj[key] += 1;
  } else {
    obj[key] = 1;
  }
};
const objAddToSet = (obj, key, val) => {
  let s = obj[key];
  if (!s) {
    s = new Set();
    obj[key] = s;
  }
  s.add(val);
};

function parseAndFillStructures(
  l,
  key,
  mentionsIds,
  usertagsCounter,
  tagsCounter
) {
  for (let i of l) {
    const parsedText = parse(i[key]);

    for (let entity of parsedText) {
      if (typeof entity === "string") {
        continue;
      } else if (entity.type === "usertag") {
        objInc(usertagsCounter, entity.humanId);

        if (entity.humanId !== i.humanId) {
          objAddToSet(mentionsIds, entity.humanId, i.humanId);
        }
      } else if (entity.type === "tag") {
        objInc(tagsCounter, entity.text);
      }
    }
  }
}

export const getNotesMeta = createSelector(
  [getHumans, getComments, getEvents],
  (humans, comments, events) => {
    const mentions = {}; // human id -> list of humans that have a mention of human id
    const usertagsOrdered = [...humans]; // humans sorted by usertag occurancies (for autocomplete)
    let tagsOrdered; // tags sorted by occurancies (for autocomplete)

    const mentionsIds = {}; // human id -> list of human ids
    const usertagsCounter = {}; // human id -> count
    const tagsCounter = {}; // tag (str) -> count

    parseAndFillStructures(
      comments,
      "text",
      mentionsIds,
      usertagsCounter,
      tagsCounter
    );
    parseAndFillStructures(
      events,
      "label",
      mentionsIds,
      usertagsCounter,
      tagsCounter
    );

    for (let k in mentionsIds) {
      const m = mentionsIds[k];
      mentions[k] = humans
        .filter((h) => m.has(h.id))
        .sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
    }

    usertagsOrdered.sort(
      (a, b) => (usertagsCounter[b.id] || 0) - (usertagsCounter[a.id] || 0)
    );

    tagsOrdered = [...Object.keys(tagsCounter)];
    tagsOrdered.sort((aKey, bKey) => tagsCounter[bKey] - tagsCounter[aKey]);
    let alreadyAddedTags = new Set();
    let uniqueTags = [];
    tagsOrdered.forEach((tag) => {
      const tagLowercase = tag.toLowerCase();
      if (alreadyAddedTags.has(tagLowercase)) return;
      alreadyAddedTags.add(tagLowercase);
      uniqueTags.push(tagLowercase);
    });
    return [mentions, usertagsOrdered, uniqueTags];
  }
);
